import { createFileRoute } from "@tanstack/react-router";
import { DEFAULT_COMPANY, isCompanyId } from "../prototype/fixtures";
import { JournalScreen } from "../screens/JournalScreen";
import { journalSearch } from "../screens/reportSearch";

export const Route = createFileRoute("/prototype/c/$companyId/journals/$entryId")({
  validateSearch: (search) => journalSearch.parse(search),
  component: JournalEntry,
});

function JournalEntry() {
  const { companyId, entryId } = Route.useParams();
  const { from } = Route.useSearch();
  return (
    <JournalScreen
      companyId={isCompanyId(companyId) ? companyId : DEFAULT_COMPANY}
      entryId={entryId}
      fromQueue={from === "queue"}
    />
  );
}
